/* globals Craft */

import { createApp } from "vue";
import App from "./vue/App.vue";

const Translate = {
  install(app) {
    app.config.globalProperties.t = (str, params) => {
      return window.Craft.t(str, params, "site");
    };
  },
};

const FormatCurrency = {
  install(app) {
    app.config.globalProperties.formatCurrency = (number) => {
      return Craft.currentSite.countryCurrency + " " + number.toFixed(2);
    };
    app.config.globalProperties.currency = () => {
      return Craft.currentSite.countryCurrency;
    };
  },
};

const app = createApp(App);
app.use(Translate);
app.use(FormatCurrency);

app.mount("#main");
